import { applyMiddleware, combineReducers, createStore, compose } from 'redux';

// Reducers
import { reducer as formReducer } from 'redux-form/immutable';
import auth from 'redux/auth/reducer';
import campaign from 'redux/campaign/reducer';
import campaigns from 'redux/campaigns/reducer';
import categories from 'redux/categories/reducer';
import companies from 'redux/companies/reducer';
import company from 'redux/company/reducer';
import contact from 'redux/contact/reducer';
import discuss from 'redux/discuss/reducer';
import featured from 'redux/featured/reducer';
import flags from 'redux/flags/reducer';
import filter from 'redux/filter/reducer';
import followUps from 'redux/followUps/reducer';
import invoices from 'redux/invoices/reducer';
import keywords from 'redux/keywords/reducer';
import listing from 'redux/listing/reducer';
import listings from 'redux/listings/reducer';
import me from 'redux/me/reducer';
import media from 'redux/media/reducer';
import medium from 'redux/medium/reducer';
import notifications from 'redux/notifications/reducer';
import orders from 'redux/orders/reducer';
import page from 'redux/page/reducer';
import plans from 'redux/plans/reducer';
import product from 'redux/product/reducer';
import products from 'redux/products/reducer';
import services from 'redux/services/reducer';
import stats from 'redux/stats/reducer';
import subscription from 'redux/subscription/reducer';
import transactions from 'redux/transactions/reducer';
import ui from 'redux/ui/reducer';
import users from 'redux/users/reducer';
import suggestions from 'redux/suggestions/reducer';
import marketData from 'redux/marketData/reducer';

const rootReducer = combineReducers({
    auth,
    campaign,
    campaigns,
    categories,
    companies,
    company,
    contact,
    discuss,
    featured,
    filter,
    flags,
    followUps,
    form: formReducer,
    invoices,
    keywords,
    listing,
    listings,
    marketData,
    me,
    media,
    medium,
    notifications,
    orders,
    page,
    plans,
    product,
    products,
    services,
    stats,
    subscription,
    suggestions,
    transactions,
    ui,
    users,
});

const isDev = process.env.NODE_ENV === 'development';
const composeEnhancers = isDev ? window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose : compose;

export default (middleware) => createStore(
    rootReducer,
    composeEnhancers(
        applyMiddleware(...middleware)
    )
);
